import { pt } from './textos'
import { somarDias } from '../../libs/hipersync'

// Uma mensagem tem um único horário diário. A faixa comum evita escolher um
// horário que o número aceite na sexta, mas não aceite no sábado.
export function horariosDoNumero(horario) {
  const linhas = Array.isArray(horario?.horarios) && horario.horarios.length ? horario.horarios : (horario?.dias || []).map(dia => ({ dia, abre: horario.abre, fecha: horario.fecha }))
  return [...linhas].sort((a, b) => (a.dia + 6) % 7 - (b.dia + 6) % 7)
}
export function faixaComum(horario) {
  if (!horario) return null
  const linhas = horariosDoNumero(horario)
  const abre = linhas.length ? linhas.reduce((maior, h) => h.abre > maior ? h.abre : maior, '00:00') : horario.abre
  if (horario.ultimoHorario !== undefined) return { abre, fecha: horario.ultimoHorario || '' }
  return { abre, fecha: linhas.length ? linhas.reduce((menor, h) => {
    const limite = h.ultimo !== undefined ? h.ultimo || '' : umaHoraAntes(h.fecha)
    return limite < menor ? limite : menor
  }, '23:59') : umaHoraAntes(horario.fecha) }
}
function umaHoraAntes(hora) {
  const [h, m] = (hora || '').split(':').map(Number)
  return h >= 1 ? `${String(h - 1).padStart(2, '0')}:${String(m).padStart(2, '0')}` : ''
}

// Dia de um envio futuro em linguagem simples: "hoje", "amanhã (seg 02/11)" ou "seg 02/11".
// A data vem pronta do servidor (no fuso da integração); só formatamos o rótulo.
export function diaDoEnvio(data, hoje) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(data || '')) return ''
  if (data === hoje) return pt.hoje.hojeDia
  const curto = new Intl.DateTimeFormat(pt.locale, { weekday: 'short', day: '2-digit', month: '2-digit', timeZone: 'UTC' }).format(new Date(`${data}T12:00:00Z`)).replace(/[.,]/g, '')
  return hoje && data === somarDias(hoje, 1) ? pt.hoje.amanha(curto) : curto
}

// Uma linha só com o horário do número, juntando dias seguidos iguais: "Seg–Sex 08:00–18:00 · Sáb 08:00–12:00".
export function resumoDoHorario(horario) {
  const nomes = pt.mensagens.diasCurtos
  const grupos = []
  horariosDoNumero(horario).forEach(h => {
    const anterior = grupos[grupos.length - 1]
    // A semana começa na segunda (posição 0) e termina no domingo (posição 6).
    const posicao = dia => (dia + 6) % 7
    const seguido = anterior && posicao(h.dia) === posicao(anterior.ultimo) + 1
    if (anterior && anterior.abre === h.abre && anterior.fecha === h.fecha && seguido) anterior.ultimo = h.dia
    else grupos.push({ primeiro: h.dia, ultimo: h.dia, abre: h.abre, fecha: h.fecha })
  })
  return grupos.map(g => `${nomes[g.primeiro]}${g.ultimo !== g.primeiro ? `–${nomes[g.ultimo]}` : ''} ${g.abre}–${g.fecha}`).join(' · ')
}

// Qual dia define o último horário comum (o que fecha mais cedo), para explicar o limite.
export function diaQueLimita(horario) {
  const faixa = faixaComum(horario)
  const linhas = horariosDoNumero(horario)
  if (!faixa?.fecha || linhas.length < 2) return null
  const limite = h => h.ultimo !== undefined ? h.ultimo || '' : umaHoraAntes(h.fecha)
  if (linhas.every(h => h.fecha === linhas[0].fecha)) return null
  const dia = linhas.find(h => limite(h) === faixa.fecha)
  return dia ? { dia: dia.dia, fecha: dia.fecha } : null
}
